import { render, staticRenderFns } from "./SidebarAddClient.vue?vue&type=template&id=12e55e0e&"
import script from "./SidebarAddClient.vue?vue&type=script&lang=js&"
export * from "./SidebarAddClient.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAddClient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports